<template>
    <div class="history-mobile-container">
        <div >
            <h1 class="history-mobile-row-title">{{ log.provider.trading_name }}</h1>
            <p>{{ log.seller.name }}</p>

        </div>
        <div class="history-mobile-row" style="margin-top: 1.5vh;">
            <div style="width: 35%;">
                <h1 class="history-mobile-collum-title">Cotação</h1>
                <p >{{ log.request.id }}</p>
            </div>
            <div  >
                <h1 style="text-align: center;" class="history-mobile-collum-title">Data</h1>
                <p style="text-align: center;">{{ log.request.created_at | formatDateOnly }}</p>

            </div>
            <div style="width: 35%;">
                <h1 class="history-mobile-collum-title" style="text-align: right;">Quantidade</h1>
                <p style="text-align: right;">{{ log.quantity || '--' }}</p>
            </div>
        </div>
        <div class="history-mobile-row">
            <div style="width: 35%;">
                <h1  class="history-mobile-collum-title">Marca</h1>
                <p >{{ log.product.brand }}</p>
            </div>
            <div>
                <h1 style="text-align: center;" class="history-mobile-collum-title">Preço</h1>
                <p style="text-align: center;">{{ log.price | currency }}</p>
            </div>

        </div>
        <div class="history-mobile-row">
            <div style="width: 35%;">
                <h1 class="history-mobile-collum-title">Fat. Min.</h1>
                <p v-if="log.delivery">{{ log.delivery.minimum_billing | currency }}</p>
            </div>
            <div  style="width: 35%;">
                <h1 class="history-mobile-collum-title" style="text-align: right;">Obs</h1>
                <p style="text-align: right;">{{ log.obs || '--' }}</p>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'ProductHistoryMobile',
    props:['log']
}
</script>
<style scoped lang="scss">
.history-mobile-container{
    display: none;
    margin-bottom: 5vh;
}
p{
    margin: 0;
    color: #605F5F;
    font-size: 1em;
}
.history-mobile-row{
    display: flex;
    justify-content: space-between;

}
.history-mobile-row-title{
    color: #605F5F;
    font-weight: bold;
    font-size: 1.2em;
    text-transform: uppercase;
    margin-bottom: 0;
    line-height: 1;
}
.history-mobile-collum-title{
    color: #605F5F;
    font-weight: bold;
    font-size: 1.1em;
    margin-bottom: 0;
}
@media only screen and (max-width: 800px) {
    .history-mobile-container{
        display: block;
    }
}
</style>
